import { SiteModel } from "./site.model";

export class CheckpointServerModel {
  constructor(
    public id: number = 0,
    public name: string = "",
    public domain: string = "",
    public userName: string = "",
    public password: string = "",
    public proxy: boolean = null,
    public sites: SiteModel[]= [],
  ) {}
}
